<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh-brk"> </p>
<p class="htoc"><span class="epub-i">Contents</span></p>
<p class="cct"><span href="#/xhtml/frontispiece#fsi" title="Link target outside of Sample">Frontispiece</span></p>
<p class="cct"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="cct"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="cct"><a href="#/xhtml/intro#intro">Introduction</a></p>
<p class="cct-sp"><a href="#/xhtml/epigraph#epi">Epigraph</a></p>
<p class="cct"><a href="#/xhtml/chapter1#ch1">1. Farewell to an Heiress</a></p>
<p class="cct"><a href="#/xhtml/chapter2#ch2">2. Fortune and Family</a></p>
<p class="cct"><a href="#/xhtml/chapter3#ch3">3. Rich Beginnings</a></p>
<p class="cct"><a href="#/xhtml/chapter4#ch4">4. Coming Out</a></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5. The Grand Tour</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6. Breaking Away</span></p>
<p class="cct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7. Countess</span></p>
<p class="cct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8. Exit the Count</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9. Enter the Argentine</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10. After the Honeymoon</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11. Making a Mark in Fashion</span></p>
<p class="cct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12. A Stylish Life</span></p>
<p class="cct"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13. Wills as Weapons</span></p>
<p class="cct"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14. Expat Idyll</span></p>
<p class="cct"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15. To the Manor</span></p>
<p class="cct"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">16. Wartime and Washington</span></p>
<p class="cct"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17. A Changed World</span></p>
<p class="cct"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">18. Bangles and Baubles</span></p>
<p class="cct"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">19. A Leading Man</span></p>
<p class="cct"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">20. After the Affair</span></p>
<p class="cct"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">21. Changing the Scene</span></p>
<p class="cct"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">22. Call of the Mountain</span></p>
<p class="cct"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">23. Taos</span></p>
<p class="cct"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">24. Travels with Millicent</span></p>
<p class="cct"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">25. One with the Indians</span></p>
<p class="cct-sp"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">26. With the Wide Sky</span></p>
<p class="cbmh"><span href="#/xhtml/postsciprt#post" title="Link target outside of Sample">Postscript</span></p>
<p class="cbmh"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="cbmh"><span href="#/xhtml/notes#not" title="Link target outside of Sample">Notes</span></p>
<p class="cbmh"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="cct"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cbmh"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Also by Cherie Burns</span></p>
<p class="cbmh"><span href="#/xhtml/copyright#copy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1ab44816